import { render, staticRenderFns } from "./OnboardingSettingsModal.vue?vue&type=template&id=40eab810&scoped=true&"
import script from "./OnboardingSettingsModal.vue?vue&type=script&lang=ts&"
export * from "./OnboardingSettingsModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40eab810",
  null
  
)

export default component.exports